<template>
  <Flex gap-3 items-center class="relative z-20 px-1 py-1 sm:px-3">
    <button type="button" class="relative rounded border border-cockpit-line p-2 text-cockpit-muted transition-colors hover:border-cockpit-green hover:text-cockpit-green focus:outline-none focus:ring-2 focus:ring-cockpit-green" aria-label="Abrir notificações" @click="notificationHidden = !notificationHidden">
      <i class="far fa-bell" aria-hidden="true"></i>
      <span class="absolute right-1 top-1 size-2 rounded-full bg-cockpit-critical" v-if="notifications.length > 0"></span>
    </button>
    <div class="flex size-8 items-center justify-center rounded-full border border-cockpit-line bg-cockpit-elevated text-xs font-semibold text-cockpit-green">{{ userInitials }}</div>
    <div>
      <div class="hidden text-xs font-semibold text-cockpit-text sm:block">{{ user?.name }}</div>
      <div class="hidden font-mono text-[9px] tracking-[0.14em] text-cockpit-muted sm:block">OPERATOR</div>
    </div>
    <ChevronY v-model="menuOpen" @click="menuOpen = !menuOpen" bt />
    <TransitionX>
      <NotificationPanel v-if="!notificationHidden" :notifications="notifications" @readNotification="readNotification" />
    </TransitionX>
    <TransitionX>
      <Card variant="cockpit" class="absolute left-auto right-0 top-full mt-2 min-w-36" v-if="menuOpen">
        <Button block cockpit outlined @click="logout()">Sair</Button>
      </Card>
    </TransitionX>
  </Flex>
</template>

<script setup>
import axios from 'axios'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { get, update } from '@/crud'
import { baseApiUrl } from '@/global'

const store = useStore()
const router = useRouter()

const user = computed(() => store.state.user)
const notificationHidden = ref(true)
const menuOpen = ref(false)
const notifications = ref([])

const userInitials = computed(() => {
  return String(user.value?.name || 'WC')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
})

const route = 'notification'

const getNotifications = async () => {
  if (!user.value?.groupIds) {
    return
  }

  const groupIds = JSON.parse(user.value.groupIds)
  const query = {
    params: {
      filters: [
        { column: 'idGroup', operator: 'in', value: groupIds },
        { column: 'readAt', operator: 'is', value: 'null' },
      ],
    },
  }

  const response = await get(route, query)
  notifications.value = response.data || []
}

const readNotification = async (notification) => {
  const id = notification.id
  const payload = { ...notification }

  ;['deletedAt', 'createdAt', 'updatedAt', 'id'].forEach((prop) => delete payload[prop])

  await update(
    route,
    id,
    {
      ...payload,
      readAt: new Date().toISOString().replace('T', ' ').split('.')[0],
    },
    'notificacao',
  )

  await getNotifications()
}

const logout = async () => {
  const url = `${baseApiUrl}/logout`
  axios.defaults.withCredentials = true
  localStorage.clear()

  try {
    await axios.post(url)
    localStorage.setItem('user', null)
    store.dispatch('setUser', null)
    router.push('/login')
  } catch (error) {
    return error
  }
}

onMounted(async () => {
  await getNotifications()
})
</script>
